import { useEffect, useState, useContext } from "react";
import { GridLayout } from "../components/layout";
import { SkeletonCardCourses } from "../atoms/skeletonloaders";
import { getAPI } from "../api/api";
import { UserContext, PageContext } from "../App";
import {SuggestedCourseComp } from "./suggestCourseComp";

export function SuggestedCourseGrid({ coursesToDisplay, selectedCourseIds, selectCourse, showMore }) {
    const [listCourses, setListCourses] = useState([]);
    const [loadingCourses, setLoadingCourses] = useState(true);

    useEffect(() => {
        if (coursesToDisplay) {
            setListCourses(coursesToDisplay);
            setLoadingCourses(false);
        }
    }, [coursesToDisplay]);
    return loadingCourses ? (
        <SkeletonCardCourses show={4}/>
    ) : (
        <GridLayout
            className={`suggest-courses-grid ${showMore ? "course-scroll" : ""}`}
            columnsTemplate="repeat(auto-fit, minmax(250px, 1fr))"
            gap="16px"
        >
            {listCourses.map((course) => (
                <SuggestedCourseComp
                    key={course.id_course}
                    onClick={() => selectCourse(course.id_course)}
                    title={course.title}
                    image={course.image_url}
                    selected={selectedCourseIds.includes(course.id_course)}
                />
            ))}
        </GridLayout>
    );
}